
import { defineComponent } from 'vue';
import PrzAuthorship from '@/components/Social/Dialogs/Parts/Authorship/Component.vue';
import { SocialThread,SocialThreadType } from '@/models/Social/social-dialog';

export default defineComponent({
    name: 'PrzThread',
    components:{
        PrzAuthorship
    },
    props: {
        showAuthor:{
            type: Boolean,
            default: true
        },
        thread:{
            type: SocialThread,
            default: null
        },
        showTranslation:{
            type: Boolean,
            default: false
        },
        isReply:{
            type: Boolean,
            default: false
        },
        kStrings:{
            type: Object,
            default: () => {
                return {
                    asked: '',
                    commented: ''
                }
            }
        }
    },
    methods:{
        threadClick(){
            this.$emit('threadclick');
        }
    },
    computed:{
        isQuestion(){
            return this.thread.type == SocialThreadType.Question;
        },
        headerText(): string{
            return this.isQuestion ? this.kStrings.asked : '';
        },
    }
});

